/* global require, Toasts */
;$(function () {
  const dotsMenuHandleSelector = '[data-dots-menu-handle]'
  const dotsMenuSelector = '[data-dots-menu]'

  $(document).on('click', dotsMenuHandleSelector, function (e) {
    e.stopPropagation()

    const $this = $(this)
    const $dotsMenu = $this.siblings('[data-dots-menu]')

    if ($dotsMenu.hasClass('dots-menu__dropdown_visible')) {
      $dotsMenu.removeClass('dots-menu__dropdown_visible')
    }
    else {
      $(dotsMenuSelector).removeClass('dots-menu__dropdown_visible')
      $dotsMenu.addClass('dots-menu__dropdown_visible')
    }

    if ($this.data('dotsMenuHandleWithLoad') && !$this.data('isLoading') && !$this.data('isLoaded')) {
      $this.data('isLoading', true)
      $dotsMenu.find('.dots-menu__preloader').removeClass('layout__none')

      const url = $this.data('url')

      $.ajax({
        url: url,
        cache: false,
        dataType: 'html',
        type: 'GET'
      })
        .done(function (response) {
          $this.data('isLoaded', true)
          $dotsMenu.get(0).insertAdjacentHTML('beforeend', response)
        })
        .fail(function (xhr) {
          var errorMessage = 'Что-то пошло не так, попробуйте позднее'

          if (typeof (xhr.responseJSON) !== 'undefined' && typeof (xhr.responseJSON.error) !== 'undefined') {
            errorMessage = xhr.responseJSON.error
          }

          Toasts.pushToast(errorMessage, 'fail', undefined, 5000)
        }).always(function () {
          $this.data('isLoading', false)
          $dotsMenu.find('.dots-menu__preloader').addClass('layout__none')
        })
    }
  })

  $(document).on('click', function () {
    $(dotsMenuSelector).removeClass('dots-menu__dropdown_visible')
  })
})
